import type { SearchUsersQueryVariables } from '../../__generated__/graphql/api';

const RESULTS_PER_PAGE = 8;

const looksLikePhone = (term: string) => /^[\d+()\-.\s]+$/.test(term) && (term.match(/\d/g)?.length ?? 0) >= 3;

export const toUserSearchVariables = (rawTerm: string): SearchUsersQueryVariables[] => {
  const term = rawTerm.trim();

  if (term.length < 2) return [];

  if (looksLikePhone(term)) {
    return [{ phoneSearch: term, resultsPerPage: RESULTS_PER_PAGE }];
  }

  const tokens = term.split(/\s+/);

  if (tokens.length >= 2) {
    return [
      {
        firstNameSearch: tokens[0],
        lastNameSearch: tokens.slice(1).join(' '),
        resultsPerPage: RESULTS_PER_PAGE,
      },
    ];
  }

  return [
    { firstNameSearch: term, resultsPerPage: RESULTS_PER_PAGE },
    { lastNameSearch: term, resultsPerPage: RESULTS_PER_PAGE },
  ];
};
